import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './css/common.css'
import 'mint-ui/lib/style.css'
import vant from 'vant';
import 'vant/lib/index.css';
import './js/common/derective';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueAxios } from './utils/request'
import { Toast } from 'vant';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);
// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
Vue.use(vant);
Vue.prototype.$toast = Toast
Vue.config.productionTip = false
// import Vconsole from 'vconsole';
// new Vconsole();
// const router = routerConfig();
// router.afterEach((to, from, next) => {
//     window.scrollTo(0, 0)
// })
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
new Vue({
    router: router(),
    store,
    render: h => h(App),
}).$mount('#app')
